<!-- 结果页弹窗  -->
<template>
  <van-popup
    v-model:show="show"
    class="result-popup"
    position="bottom"
    :close-on-click-overlay="false"
  >
    <div class="container">
      <img class="icon" :src="formData.icon" alt="" />
      <h2>{{ formData.title }}</h2>
      <p>{{ formData.sub }}</p>

      <div class="btn-row">
        <van-button type="primary" @click="onSubmit" round> 好的 </van-button>
      </div>
    </div>
  </van-popup>
</template>

<script setup>
import { reactive, ref, computed, onMounted, defineExpose, defineEmits, defineProps, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRouter, } from "vue-router";
import { Toast } from 'vant';
import { zfbNameTest } from '@/utils/validate'
import anime from 'animejs/lib/anime.es.js';

const emit = defineEmits([]);   //定义一个变量来接收父组件传来的方法
const props = defineProps({
  // types: {
  //   default: () => []
  // }, // 平台类型
})

const store = useStore()
const router = useRouter();

const show = ref(false)
const formData = reactive({
  title: '',
  sub: '',
  icon: require('@/assets/imgs/scenario/signInGift/pic16.png'),
  toRecord: false,
}) // 签到获得的奖品可前往“签到页面-我的奖品”查看

const handleClose = () => {

  // 弹窗动画-从大变小从底部消失
  anime({
    targets: '.result-popup',
    bottom: ['30%', '0%'],
    scale: [1, 0.1],
    duration: 300,
    easing: 'easeInOutSine',
    complete: () => {
      show.value = false
    }
  })

  setTimeout(() => {
    formData.title = ''
    formData.sub = ''
    formData.icon = require('@/assets/imgs/scenario/signInGift/pic16.png')
    formData.toRecord = false
  }, 300)
}
const handleOpen = (obj) => {
  // console.log(obj);

  formData.title = obj.title || ''
  formData.sub = obj.sub || ''
  if (obj.icon !== undefined) {
    formData.icon = obj.icon
  }
  if (obj.toRecord !== undefined) {
    formData.toRecord = obj.toRecord
  }
  show.value = true
}

// 提交
const onSubmit = () => {
  handleClose()
  if (formData.toRecord) {
    setTimeout(() => {
      router.push({
        name: 'signInRecord'
      })
    }, 400)
  }
}



defineExpose({
  handleClose,
  handleOpen,
})

</script>

<style lang="less" >
.fade-enter-active,
.fade-leave-active {
  // transition: transform 2.5s ease, opacity 0.5s ease;
  transition: all 1.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  // opacity: 0;
  transform: scale(0); /* 缩小到0 */
  // transform: translateY(50px); /* 初始位置在底部 */
  transform: translateX(50px);
}
</style>
<style lang="less">
.result-popup {
  left: 7%;
  .container {
    background: #fff;
    border-radius: 20px;
    width: 320px;
    text-align: center;
    padding: 15px 0;

    .card {
      padding: 0 15px;
    }

    .icon {
      width: 109px;
    }

    h2 {
      font-size: 18px;
      text-align: center;
      font-weight: 600;
      line-height: 3;
    }

    p {
      margin: 0 5px 0 15px;
      color: #b2b2b7;
      font-size: 12px;
      line-height: 1.5;
    }

    .btn-row {
      display: flex;
      justify-content: space-evenly;
      color: #fff;

      button {
        margin: 25px 0 0px 0;
        width: 125px;
      }
    }
  }
}
</style>
